import React, {createContext, useCallback, useContext, useState} from 'react'
import {toast} from 'react-toastify'
import {ErrorModal, FatalModal} from './components'

export const MODAL_TYPES = {
  SUCCESS_TOAST: 'SUCCESS_TOAST',
  SUCCESS_MODAL: 'SUCCESS_MODAL',
  WARNING_TOAST: 'WARNING_TOAST',
  ERROR_MODAL: 'ERROR_MODAL',
  FATAL_MODAL: 'FATAL_MODAL',
}

/// Modeled after ResponseType in API
export const RESPONSE_TYPES = {
  TOAST: 0,
  MODAL: 2
}

const MODAL_COMPONENTS: any = {
  [MODAL_TYPES.SUCCESS_MODAL]: ErrorModal,
  [MODAL_TYPES.ERROR_MODAL]: ErrorModal,
  [MODAL_TYPES.FATAL_MODAL]: FatalModal,
}

type MessageModalContextType = {
  showModal: (modalType: string, modalProps?: any) => void
  hideModal: () => void
  store: any
}

const initalState: MessageModalContextType = {
  showModal: () => {},
  hideModal: () => {},
  store: {},
}

interface MessageModalPropertyModel {
  modalType: string
  modalProps?: any
}

const MessageModalContext = createContext(initalState)
export const useMessageModalContext = () => useContext(MessageModalContext)

export const MessageModal: React.FC<{}> = ({children}) => {
  const [store, setStore] = useState<MessageModalPropertyModel>()
  const {modalType, modalProps} = store || ({} as MessageModalPropertyModel)

  const showModal = useCallback(
    (modalType: string, modalProps: any = {}) => {
      switch (modalType) {
        case 'WARNING_TOAST':
          toast.warning(modalProps.message)
          return
        case 'SUCCESS_TOAST':
          toast.success(modalProps.message)
          return
        case 'SUCCESS_MODAL':
          setStore({
            ...store,
            modalType,
            modalProps,
          })
          return
        case 'ERROR_MODAL':
          setStore({
            ...store,
            modalType,
            modalProps,
          })
          return
      }
    },
    [store]
  )

  const hideModal = () => {
    setStore({
      ...store,
      modalType: '',
      modalProps: {},
    })
  }

  const renderComponent = () => {
    const ModalComponent = MODAL_COMPONENTS[modalType]
    if (!modalType || !ModalComponent) {
      return null
    }
    return <ModalComponent id='global-modal' {...modalProps} />
  }

  return (
    <MessageModalContext.Provider value={{store, showModal, hideModal}}>
      {renderComponent()}
      {children}
    </MessageModalContext.Provider>
  )
}
